import { render, staticRenderFns } from "./UserReviews.vue?vue&type=template&id=90d6c518"
import script from "./UserReviews.vue?vue&type=script&lang=js"
export * from "./UserReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports